export class SandersonVideos {
    constructor () {
        this.modal = null
        this.videoEl = null
        this.sandersonVideoCards = []

        this.init()
    }

    init () {
        this.setupModal()

        document.querySelectorAll('.sanderson-video-item').forEach(card => {
            // console.log('test')
            const videoId = card.dataset.videoId
            card.addEventListener('click', () => {
                this.openModal(videoId)
            })
            this.sandersonVideoCards.push({
                el: card,
                videoId: videoId
            })
        })
    }

    setupModal () {
        this.modal = document.createElement('div')
        const modalFadeEl = document.createElement('div')
        this.videoEl = document.createElement('div')

        this.modal.classList.add('sf-video-modal')
        modalFadeEl.classList.add('sf-video-modal__fade')
        this.videoEl.classList.add('sf-video-modal__video')

        this.modal.appendChild(modalFadeEl)
        this.modal.appendChild(this.videoEl)

        document.body.appendChild(this.modal)

        modalFadeEl.addEventListener('click', () => {
            this.closeModal()
        })
    }

    openModal (id) {
        this.modal.classList.add('sf-video-modal--open')

        this.videoEl.innerHTML = `<iframe
class="sf-video-modal__player"
src="https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0"
title="YouTube video player"
frameborder="0"
allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
allowfullscreen></iframe>`
    }

    closeModal () {
        this.videoEl.innerHTML = ``
        this.modal.classList.remove('sf-video-modal--open')
    }
}
